import { UnikoServiceTypes } from "src/app/services/payments-api.service";
import { availableServices } from "./available-services";
import * as environment from '../../../../core/appSettings';
import { EnvironmentInjector } from "@angular/core";

export const legalReportService = (injector: EnvironmentInjector) => ({
    title: 'legalReport.title',
    img: '../../../../assets/img/property-service-legalreport.png',
    reportSampleDocumentName: 'Legal-Report-Template',
    reportSampleImageUrl: '',
    descPart1: `legalReport.descriptionPart1`,
    descPart2: `legalReport.descriptionPart2`,
    descPart3: `legalReport.descriptionPart3`,
    section1Title: 'whyChooseService',
    section1Description: 'legalReport.whyChoose.description',
    deliveryDays: 7,
    serviceFee: 200,
    whyChooseService: [
      {
        icon: 'icon-browse-property',
        title: 'legalReport.whyChoose.title1',
        description: 'legalReport.whyChoose.description1'
      },
      {
        icon: 'icon-needs-renovation',
        title: 'legalReport.whyChoose.title2',
        description: 'legalReport.whyChoose.description2'
      },
      {
        icon: 'icon-auction',
        title: 'legalReport.whyChoose.title3',
        description: 'legalReport.whyChoose.description3'
      }
    ],
    section2Title: 'nextSteps',
    nextSteps: [
      'legalReport.nextSteps1',
      'legalReport.nextSteps2',
      'legalReport.nextSteps3'
    ],
    extraSection: 'legalReport.extraSection',
    section3Title: 'lookAtTheseServices.title',
    section3Description: 'lookAtTheseServices.description',
    services: availableServices.filter((service) => service.type !== UnikoServiceTypes.legalReport),
    requestServiceButtonLabel: 'legalReport.requestLegalReport',
  });